@import '../../styles/fonts.scss';

.modal {
  min-width: 50%;

  .modalContainer {
    display: flex;
    gap: 1em;
    flex-direction: column;

    .row {
      display: flex;
      gap: 1em;
    }
    .rowItem {
      flex: 1;
    }
  }
}

.container {
  display: flex;
  flex-direction: column;

  .dropdownRow {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 1em;

    .dropdownMenu {
      width: 35em;
    }

    .buttonGroup {
      display: flex;
      gap: 1em;
      border-bottom: 0.05em solid transparent;
    }
  }

  .gruppeBeskrivelse {
    @include barlow(14);
    margin-top: 2em;
  }

  .kriterierContainer {
    display: flex;
    flex-direction: column;
    row-gap: 2em;

    .kriterieBeskrivelse {
      width: 80%;
      @include barlow(14);
    }

    .kriterieButton {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.textArea {
  width: 100%;
  min-height: 7em;
}

.createButton {
  margin-top: 5em;
  width: fit-content;
}
